module.exports = __webpack_public_path__ + "img/Lsg_Schalldruck.724e3b7b.jpg";